<!-- Tipo de avaliação -->
<p>
  Tipo de dispositivo:
  {{
    filter().responseDevice === 0
      ? "Todos"
      : filter().responseDevice === 1
      ? "Totens/dispositivos"
      : "Pesquisa online"
  }}
</p>

<p>
  Tipo de avaliação:
  {{
    filter().responseType === 1
      ? "Incompletas"
      : filter().responseType === 2
      ? "Completas"
      : "Todos"
  }}
</p>

<!-- Branchs selecionadas -->
@if(filter().branchesId.length && filter().branchesName){
<p>
  Unidades: @for (branch of filter().branchesName; track $index) {
  {{ branch }}@if (filter().branchesName && $index <
  filter().branchesName!.length - 1) {, } }
</p>
}

<!-- Dados do perfil e usuário selecionado -->
@if(filter().branchOrUser === 1){
<p>Perfil: {{ filter().profileName ?? "" }}</p>
<p>Usuário selecionado do perfil: {{ filter().userName ?? "" }}</p>
}

<!-- Datas do filtro -->
<p>
  Período:
  {{ filter().startDate | date : "dd/MM/yyyy" }} à
  {{ filter().finishDate | date : "dd/MM/yyyy" }}
</p>

<!-- Dia da semana -->
@if (filter().weekDayName) {
<p>Dia da semana: {{ filter().weekDayName }}</p>
}

<!-- Turnos -->
@if(filter().avaiableShiftsDescription && filter().avaiableShiftsDescription){
<p>
  Turnos: @for (shifts of filter().avaiableShiftsDescription; track $index) {
  {{ shifts }}@if (filter().avaiableShiftsDescription && $index <
  filter().avaiableShiftsDescription!.length - 1) {, } }
</p>
}

<!-- Dispositivos -->
@if(filter().devicesName?.length){
<p>
  Dispositivos: @for (device of filter().devicesName; track $index) {
  {{ device }}@if (filter().devicesName && $index <
  filter().devicesName!.length - 1) {, } }
</p>
}

<!-- Horário selecionado no Filtro -->
@if(filter().startTime && filter().finishTime){
<p>Horário: {{ filter().startTime }}Hs às {{ filter().finishTime }}Hs</p>
}
